import { cookies } from '@/utils/cookies';

import { getAlgoliaInsights } from './storage';
import {
  type GetAlgoliaEventProps,
  type GetAlgoliaInsightsProps,
} from './types';

export const getAlgoliaEventProps = (): GetAlgoliaEventProps => {
  const algoliaInsights = getAlgoliaInsights();

  const userId = cookies.client.get('user_id').value;

  const shouldSendEventToAlgolia = Boolean(algoliaInsights?.queryID);

  return {
    userId,
    algoliaInsights,
    shouldSendEventToAlgolia,
  };
};

export const mountAlgoliaEvent = (
  algoliaInsights: GetAlgoliaInsightsProps,
  userId?: string
) => {
  return {
    objectIDs: [algoliaInsights.objectID],
    queryID: algoliaInsights.queryID,
    index: algoliaInsights.indexName,
    ...(userId ? { userToken: userId } : { useCookie: true }),
  };
};
